export default __webpack_public_path__ + "static/media/Roboto-Light.f71e5492.ttf";